import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import useAPI from '@/hooks/useAPI';
import AuditLogRepository from '@/repositories/AuditLogRepository';
import { AuditLogRequestParams } from '@/types/auditLog';
import { AUDITLOG_VIEW_LOGENTRY, hasPermission } from '@/utils/userPermission';

const useAuditLog = (params: AuditLogRequestParams, enabled = true) => {
  const { permissions } = useContext(AppContext);
  const auditLogRepository = AuditLogRepository();
  const hasAuditLogPermission = hasPermission({
    permissions,
    requiredPermission: AUDITLOG_VIEW_LOGENTRY
  });

  return useAPI({
    queryKey: ['auditLog', params.appLabel, params.model, params.objectId],
    queryFn: async () => {
      return await auditLogRepository.getAuditLog(params);
    },
    enabled: enabled && hasAuditLogPermission
  });
};

export default useAuditLog;
